import { useQuery } from "@tanstack/vue-query"
import { computed } from "vue"
import useAsclepius from "@common/composables/api/asclepius"
import { GetMemberProfileResponse } from "@vitable/asclepius-api-client-ts"

interface MemberProfileWithHealthWallet {
  health_wallet_access_in?: boolean
  [key: string]: any
}

export function useMemberProfile(memberId: string) {
  const { getMemberApi } = useAsclepius()

  const {
    data: memberProfileResponse,
    isLoading,
    error,
    refetch
  } = useQuery<GetMemberProfileResponse>({
    queryKey: ["memberProfile", memberId],
    queryFn: async () => {
      const response = await getMemberApi().getMemberProfile({ memberId })
      return response.data
    },
    enabled: !!memberId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })

  const memberProfile = computed<MemberProfileWithHealthWallet | null>(() => {
    return memberProfileResponse.value || null
  })

  const hasHealthWalletAccess = computed(() => {
    return memberProfileResponse.value?.profile?.health_wallet_access_in ?? false
  })

  return {
    memberProfile,
    hasHealthWalletAccess,
    isLoading,
    error,
    refetch
  }
}
